import React, { Fragment, HTMLAttributes } from 'react';
import { useTranslation } from 'react-i18next';
import { connect } from 'formik';
import { Paper } from '@mui/material';
import AddIcon from '@mui/icons-material/Add';
import AsyncAutocomplete from '@ui-lib/components/Inputs/Autocomplete/AsyncAutocomplete';
import ModalWindow from '@ui-lib/components/ModalWindow';
import Button from '@ui-lib/components/Button';
import { createSx } from '@ui-lib/utils';
import { getLocationsSuggestions } from '@web-shared/api/autocomplete/locations';
import { useModal } from '@web-shared/hooks';
import { GROUND_LOCATION_TYPES } from '@oh-main-modules/global/modules/Locations/consts';
import CreateLocationContent from './components/CreateLocationContent';

const sx = createSx({
  btn: {
    justifyContent: 'flex-start',
  }
});

const apiCallParams = {
  filters: {
    types: GROUND_LOCATION_TYPES,
  }
};

const LocationSelect = connect(({ formik }) => {
  const [open, toggleModal] = useModal();

  const { t } = useTranslation();

  const PaperComponent: React.FC<HTMLAttributes<HTMLElement>> = ({ children, ...props }) => {
    return (
      <Paper {...props} onMouseDown={event => event.preventDefault()} elevation={1}>
        <Button
          sx={sx.btn}
          variant='text'
          startIcon={<AddIcon />}
          onClick={toggleModal}
          fullWidth>
          {t('label_createNewLocation')}
        </Button>
        <>{children}</>
      </Paper>
    );
  };

  return (
    <Fragment>
      <AsyncAutocomplete
        withFormik
        required
        name="location"
        label={t('destinationLocation')}
        apiCall={getLocationsSuggestions}
        apiCallParams={apiCallParams}
        slots={{ paper: PaperComponent }}
      />
      <ModalWindow open={open} onClose={toggleModal}>
        <CreateLocationContent
          onClose={toggleModal}
          onLocationCreated={(location) => formik.setFieldValue('location', location)}
        />
      </ModalWindow>
    </Fragment>
  );
});

export default LocationSelect;